import { Zap } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { CASE_LABELS, CASE_ORDER } from "@/constants/content";

export const PresetLoader = ({ onLoad }) => {
  const { reports } = useApp();
  return (
    <div data-testid="intake-preset-loader">
      <p className="mb-2 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-300">
        <Zap className="h-3.5 w-3.5 text-amber-300" aria-hidden="true" /> Quick-load a preset scenario
      </p>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {CASE_ORDER.map((slug) => {
          const idea = reports[slug]?.idea;
          return (
            <button key={slug} type="button" disabled={!idea}
              onClick={() => onLoad({ idea_text: idea.idea_text, country_code: idea.country_code, city_region: idea.city_region || "", target_audience: idea.target_audience || "" })}
              className="min-w-0 rounded-xl border border-white/10 bg-white/[0.03] px-2.5 py-2 text-left text-xs font-semibold text-slate-200 transition-[border-color,background-color] hover:border-cyan-400/50 hover:bg-cyan-500/5 disabled:opacity-40"
              data-testid={`intake-preset-${slug}`}>
              <span className="mr-1">{idea?.case_study_meta?.flag}</span>
              <span className="break-words">{CASE_LABELS[slug].label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
